import { errors } from 'lib_ui-primitives';
import genericRule from '../namespace/relation/doingValidate_namespace_relation';

export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'print',
    relation: 'template',
    priority: genericRule.priority + 10, // before the generic rule
    description: 'Require custom ZPL to be entered if selected',
    logic: doingValidate
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 *
 * @typedef {object} TemplateValidationPayload
 * @property {object} newRecord
 * @property {Array<object>} [newRecord.actions]
 *
 * @typedef {{
 *   data: TemplateValidationPayload;
 *   prerequisiteResults?: Array<{result:Array<object>}>;
 *   context: Context;
 *   workflowStack?: WorkflowStack[];
 *   dispatch?: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log?: LoggingProvider
 * }} Message
 *
 */

/**
 * @param {Message} message
 * @returns {Message}
 */
function doingValidate(message) {
    const { actions } = message.data.newRecord;
    let fieldErrors = {};
    let hasErrors = false;
    const customZPLNode = actions?.find(node => node.hNodeType === 'CustomZplContent');
    if (customZPLNode) {
        if (actions.length > 1) {
            const errorMessage = 'When Custom ZPL is selected, no other content is allowed.';
            fieldErrors.actions = errorMessage;
            hasErrors = true;
        } else if (!customZPLNode.customZpl || customZPLNode.customZpl.trim() === '') {
            const errorMessage = 'Custom ZPL content is required when Custom ZPL is selected.';
            fieldErrors.actions = errorMessage;
            hasErrors = true;
        } else if (!customZPLNode.customZpl.includes('^XA') || !customZPLNode.customZpl.includes('^XZ')) {
            const errorMessage = 'Custom ZPL must include ^XA at the beginning and ^XZ at the end.';
            fieldErrors.actions = errorMessage;
            hasErrors = true;
        }
    }
    if (hasErrors) {
        let message = 'There are problems with this Print Job.  For details, see the red message(s) above.';
        throw new errors.ValidationError(message, fieldErrors);
    }
    return message;
}
